

































































































































































import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import { CompanyRoleSearchItem } from '@/interfaces/search/company-role-search-item';
import DropdownIconBar from '@/components/dropdowns/dropdown-icon-bar.vue';
import { File } from '@/interfaces/file';
import { formatUtils } from '@/util/format-utils';
import { List } from '@/interfaces/list';
import { RouterNames } from '@/util/enums/router-names';
import { TableSizes } from '@/util/enums/table-sizes';

@Component({
  components: {
    DropdownIconBar,
  },
})
export default class CompanyRoleList extends Vue {
  @Prop({ required: true }) companyRoles: CompanyRoleSearchItem[];
  @Prop({ default: false }) showNotes: boolean;
  @Prop({ default: null}) list: List;
  @Prop({ default: null }) filterFunc: (val: CompanyRoleSearchItem) => boolean;
  @Prop({ default: null }) limit: number;
  @Prop({ default: 'trademark' }) headerColor: string;
  @Prop({ default: 'white' }) headerText: string;
  @Prop({ default: 'white' }) itemColor: string;
  @Ref() companyRoleTableContainer: HTMLDivElement;
  tableSize = 4000;
  allowClick = false;

  mounted() {
    window.addEventListener('resize', this.resizeHandler);
    this.resizeHandler();
  }

  activated() {
    this.resizeHandler();
  }

  get colClassesXl() {
    if (this.tableSize > TableSizes.xxl) {
      return [
        'col-1',
      ];
    } else {
      return [
        'col-2',
      ];
    }
  }

  get headerClasses() {
    return [
      'mb-2',
      `bg-${this.headerColor}`,
      `text-${this.headerText}`,
    ];
  }

  get items(): CompanyRoleSearchItem[] {
    const items: CompanyRoleSearchItem[] = this.companyRoles.filter(this.filterFunc ?? (() => true));
    if (this.limit != null) {
      return items.splice(0, this.limit);
    }
    return items;
  }

  get isShared(): boolean {
    return this.list && this.list.paUserIds.length > 1;
  }

  get userBlacklist() {
    return this.$vmx.blacklist.userBlacklists;
  }

  firstCriteriaText(text: string): string {
    return text ? this.formatText(text, 15) : (this.$t('general.emptyField') as string);
  }

  formatDate(date: string) {
    return formatUtils.formatDate(date, 'DD.MM.YYYY');
  }

  formatText(text: string, maxChars: number) {
    if (text.length > maxChars) {
      return text.substring(0, maxChars) + '&hellip;';
    } else {
      return text;
    }
  }

  getCriteriaStringsOfType(companyRole: CompanyRoleSearchItem, typeId: number): string[] {
    return companyRole.project.criteria?.find(criterionData => criterionData.typeId === typeId)?.criteria ?? [];
  }

  imageFromFile(file: File) {
    if (file) {
      return 'url(' + (file.link ? file.link : this.$vmx.file.fromFile(`${file.code}.${file.extension}`, '1x1')) + ')';
    } else {
      return 'url(' + this.$vmx.file.fromFile(null, '1x1') + ')';
    }
  }

  public resizeHandler() {
    if (this.companyRoleTableContainer) {
      this.tableSize = this.companyRoleTableContainer.clientWidth;
    }
  }

  routerLink(id: number) {
    return {
      name: RouterNames.LOGGED_IN_PROJECT_VIEW,
      params: { id: id.toString() },
    };
  }

  showAtSize(minSize: number) {
    return [
      this.tableSize < minSize ? 'd-none' : '',
    ];
  }
}
